import React, { useEffect } from "react";
import { Link } from "gatsby";

const SmallRoadmapSection = ({ content }) => {
	useEffect(() => {
        const someElementsItems = document.querySelectorAll("#roadmap-item.active");
        someElementsItems[someElementsItems.length -1].classList.add("last-item")
	}, []);

	return (
		<section className='roadmap'>
			<div className='container'>
				<div className='row'>
					<div className='col-12 col-md-5 col-lg-4'>
						<h2 id='roadmap'>{content.title}</h2>
						<div className='text'>
							<Link to={content.ctaUrl} className={`btn`}>
								{content.ctaText}
							</Link>
						</div>
					</div>
					<div className='col-12 col-md-6 ms-auto pt-5 pt-md-0'>
						<ul>
							{content.elements &&
								content.elements.map((element, index) => {
									return (
										<li id='roadmap-item' className={element.checked && "active"} key={index}>
											<div className='inner'>
												<div className='date'>{element.subtitle}</div>
												<div className='title'>{element.title}</div>
											</div>
										</li>
									);
								})}
						</ul>
					</div>
				</div>
			</div>
		</section>
	);
};

export default SmallRoadmapSection;
